import Manager from "../manager/Manager";

export default function useManager() {
  const MAN = Manager.getInstance();
  return MAN;
}
